<table class="ir-plugin-table" style="margin-bottom: 10px">
  <tr *ngIf="incoterms?.Value && incoterms?.Value >= 0">
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ 'plugins.installationincoterms.incoterms' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1">{{ incoterms.Value | incoterms }}</span>
      </p>
    </td>
  </tr>
  <tr *ngIf="incoterms?.Destination">
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ 'plugins.installationincoterms.destination' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1">{{ incoterms.Destination }}</span>
      </p>
    </td>
  </tr>
</table>
